/**
 * Copyright (c) 2018 itemis AG - All rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 *
 * Contributors:
 * 	andreas muelder - itemis AG
 *
 */
import { shapes, util, ui } from "@clientio/rappid";
import { PreferenceStore } from "../services/preference-store";
import { BaseNode, BaseView } from "./base/base-node";
import { ElementController } from "./base/element-controller";
import { MARKER } from "./base/validation";

export class Final extends BaseNode {
  defaults() {
    return {
      ...super.defaults,
      type: "Final",
      size: {
        height: 15,
        width: 15,
      },
      fixedRatio: true,
      embedable: false,
      linkable: true,
      attrs: {
        root: {
          magnetSelector: "body",
        },
        marker: {
          text: MARKER,
          fontFamily: "FontAwesome",
          fontSize: 13,
          x: -5,
          y: 0,
          opacity: 0,
        },
        body: {
          refCx: "50%",
          refCy: "50%",
          refR: "50%",
          fillOpacity: 1,
          strokeOpacity: 1,
          strokeWidth: 1,
        },
        innerWhite: {
          refCx: "50%",
          refCy: "50%",
          refR: "43%",
          fillOpacity: 1,
        },
        innerBlack: {
          refCx: "50%",
          refCy: "50%",
          refR: "35%",
          fillOpacity: 1,
        },
      },
    };
  }

  getFillColor(): string {
    return this.attr(["body", "fill"]);
  }

  setFillColor(color: string | null) {
    this.attr(["body", "fill"], color);
    this.attr(["innerBlack", "fill"], color);
    if (color === null) {
      this.removeAttr(["body", "fill"]);
      this.removeAttr(["innerBlack", "fill"]);
    }
  }

  getBorderColor(): string {
    return this.attr(["innerWhite", "fill"]);
  }

  setBorderColor(color: string | null) {
    this.attr(["innerWhite", "fill"], color);
    if (color === null) {
      this.removeAttr(["innerWhite", "fill"]);
    }
  }

  getBorderWidth(): number {
    return this.attr(["body", "strokeWidth"]) || 0;
  }

  setBorderWidth(width: number) {
    this.attr(["body", "strokeWidth"], width);
  }

  resetDefaults() {
    this.setFillColor(null);
    this.setBorderColor(null);
    this.setBorderWidth(1);
  }

  markup = [
    {
      tagName: "circle",
      selector: "body",
    },
    {
      tagName: "circle",
      selector: "innerWhite",
    },
    {
      tagName: "circle",
      selector: "innerBlack",
    },
    {
      tagName: "text",
      selector: "marker",
    },
  ];
}

export class FinalView extends BaseView {}

export class FinalController extends ElementController {
  getHaloConfig() {
    return [
      {
        name: "remove",
        position: ui.Halo.HandlePosition.NW,
        events: { pointerdown: "removeElement" },
        attrs: {
          ".handle": {
            "data-tooltip-class-name": "small",
            "data-tooltip": "Remove the object",
            "data-tooltip-position": "right",
            "data-tooltip-padding": 25,
          },
        },
      },
    ];
  }
}

util.assign(shapes, {
  Final,
  FinalView,
  FinalController,
});
